import React from "react";
import { useLang } from "../../context/LanguageContext";

const Gallery = ({ items }) => {
  const { t } = useLang();
  if (!items?.length) return null;

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 sm:py-32 bg-[#0A0A0C]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-16 max-w-2xl">
          <div className="text-xs tracking-[0.4em] uppercase text-[#D4AF37] mb-6">
            {t("gallery.overline")}
          </div>
          <h2 className="font-display font-light text-4xl sm:text-5xl md:text-6xl tracking-tighter text-white leading-[1]">
            {t("gallery.title")}
          </h2>
          <p className="mt-6 text-base text-white/60 leading-relaxed">
            {t("gallery.subtitle")}
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 md:gap-6 space-y-4 md:space-y-6">
          {items.map((item, idx) => (
            <div
              key={item.id}
              data-testid={`gallery-item-${idx}`}
              className="relative overflow-hidden break-inside-avoid group cursor-pointer"
            >
              <img
                src={item.image_url}
                alt={`gallery-${idx}`}
                className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-[#0A0A0C]/0 group-hover:bg-[#0A0A0C]/30 transition-colors duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="h-px w-12 bg-[#D4AF37] mb-2" />
                <div className="text-[10px] tracking-[0.3em] uppercase text-white">
                  İstanbul Organizasyon
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
